/* ── Boss Bidet Revolution V2 — patch layer (loaded after bb-rev2.js) ──
   Small add-on so the large bb-rev2.css / bb-rev2.js stay untouched.

   1. MOBILE: hide the Shopify Inbox chat bubble (#ShopifyChat) while the
      finish / quantity sheet is open — it sits at max z-index bottom-right and
      would otherwise cover the sheet's "Add to Cart" button.
   2. DESKTOP: enlarge the centered finish / quantity sheet so the finish
      picker is easier to use when opened from a CTA / the floating buy bar.
*/
(function () {
  'use strict';

  var CSS = [
    '@media (max-width: 768px){',
    /* Shopify Inbox's <inbox-online-store-chat> uses a shadow :host{display:block!important},
       which beats an outer display:none — visibility:hidden is what actually hides it. */
    '  body.bb-rev2-sheet-open #ShopifyChat{visibility:hidden !important;pointer-events:none !important;}',
    '}',
    '@media (min-width: 769px){',
    '  .bb-rev2-sheet-panel{max-width:640px !important;width:calc(100% - 48px) !important;padding:34px 36px 38px !important;border-radius:16px !important;}',
    '  .bb-rev2-sheet-head{font-size:19px;margin-bottom:20px;}',
    '  .bb-rev2-sheet-variants{gap:14px;margin-bottom:22px;}',
    '  .bb-rev2-sheet-variant{width:92px;padding:11px 8px 9px;border-radius:10px;}',
    '  .bb-rev2-sheet-variant img{width:64px;height:64px;border-radius:7px;}',
    '  .bb-rev2-sheet-variant span{font-size:12px;}',
    '  .bb-rev2-sheet-row{gap:14px;}',
    '}'
  ].join('\n');

  function inject() {
    if (document.getElementById('bb-rev2-x-style')) return;
    var s = document.createElement('style');
    s.id = 'bb-rev2-x-style';
    s.textContent = CSS;
    /* Append to end of <body> so it wins over bb-rev2.css (same specificity). */
    (document.body || document.head || document.documentElement).appendChild(s);
  }

  /* Keep body.bb-rev2-sheet-open in sync with the sheet's visibility, so the
     mobile chat-hide rule applies without touching bb-rev2.js's openSheet(). */
  function initSheetSync() {
    var sheet = document.getElementById('bb-rev2-sheet');
    if (!sheet) return;
    function sync() {
      document.body.classList.toggle('bb-rev2-sheet-open', !sheet.hidden);
    }
    new MutationObserver(sync).observe(sheet, { attributes: true, attributeFilter: ['hidden'] });
    sync();
  }

  function init() { inject(); initSheetSync(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
